export default __webpack_public_path__ + "1ef356fa0688942b05134e9e627f9c37.svg";